import { combineReducers } from "redux";
import { Configuration, employeeReducer, task, teamManagementReducer, userLeaveDetails, } from "./reducers";
const reducers = combineReducers({
    allEmployee: employeeReducer,
    team: teamManagementReducer,
    configuration: Configuration,
    task: task,
    userLeaveDetails: userLeaveDetails
});
export default reducers